import AskDbLayout from './askDbLayout.component';

export default AskDbLayout;
